import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { urlRegex } from "@app/shared/validators/validUrl";
interface SvgChange {
    type: string;
    xml: string;
}
const willRequireOverflowContactLine = (url: string): boolean => url.length > 30;
@Component({
    selector: "app-preview-custom-screen",
    templateUrl: "./preview-custom-screen.component.svg",
    styleUrls: ["./preview-custom-screen.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewCustomScreenComponent implements OnInit, OnChanges {
    @Input() customScreenForm: FormGroup;
    @Output() emitSvgChanges = new EventEmitter<SvgChange>();

    constructor(@Inject(DOCUMENT) private _document: Document) {}

    ngOnInit(): void {
        if (this.customScreenForm) {
            this.updateElementValues(this.customScreenForm.value);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.customScreenForm.currentValue) {
            this.updateElementValues(changes.customScreenForm.currentValue.value);
        }
    }

    private updateElementValues(formGroupValue: Record<string, string>) {
        const logoHint = this._document.getElementById("logo-hint");
        logoHint.style.visibility = "hidden";
        const elementIds = Object.keys(formGroupValue);

        elementIds.forEach(id => {
            if (id === "logo") {
                const logo = document.getElementById(id);
                if (formGroupValue[id]) {
                    logo.setAttribute("href", "data:image/png;base64," + formGroupValue[id]);
                } else {
                    logo.setAttribute("href", "");
                }
            } else if (formGroupValue[id]) {
                if (["contactLine1", "contactLine2", "contactLine3"].includes(id)) {
                    this.handleContactLine(formGroupValue[id], id);
                } else {
                    document.getElementById("svg-" + id).textContent = formGroupValue[id];
                }
            } else {
                document.getElementById("svg-" + id).style.display = "none";
            }
        });

        const dataSubmit = new XMLSerializer().serializeToString(document.getElementById("svg_c1"));
        this.emitSvgChanges.emit({ type: "submit", xml: dataSubmit });
        logoHint.style.visibility = !formGroupValue["logo"] ? "visible" : "hidden";
        const dataPreview = new XMLSerializer().serializeToString(document.getElementById("svg_c1"));
        this.emitSvgChanges.emit({ type: "preview", xml: dataPreview });
    }

    private addHttpsToContact(urlArray: string[], urlContact: HTMLElement) {
        const hasHttps = urlArray.some(str => str === "https:");
        if (hasHttps) {
            urlContact.textContent = "https://";
            urlArray.splice(0, 2);
        }
    }

    private addOverflowToContact(urlArray: string[], urlContact: HTMLElement, urlContactOverflow: HTMLElement) {
        if (urlArray.length > 1) {
            urlContact.textContent += `${urlArray[0]}/`;
            urlArray.shift();
            this.addPathToUrl(urlArray, urlContact, urlContactOverflow);

            this.decreaseFontSize(urlContact, urlContactOverflow);
            this.hideUrlContactOverflowContent(urlContactOverflow);
            return;
        }

        urlContact.textContent += urlArray;
        this.decreaseFontSize(urlContact);
        this.hideUrlContactOverflowContent(urlContactOverflow);
    }

    private hideUrlContactOverflowContent(urlContactOverflow: HTMLElement) {
        if (!urlContactOverflow.textContent) {
            urlContactOverflow.style.display = "none";
        }
    }

    private decreaseFontSize(urlContact: HTMLElement, urlContactOverflow: HTMLElement = null) {
        const urlContactLength = urlContact.textContent.length;
        if (urlContactLength <= 41) {
            urlContact.style.fontSize = "32px";
        } else {
            urlContact.style.fontSize = "24px";
        }
        if (urlContactOverflow) {
            urlContactOverflow.style.fontSize = urlContact.style.fontSize;
        }
    }

    private addPathToUrl(urlArray: string[], urlContact: HTMLElement, urlContactOverflow: HTMLElement) {
        let updatedUrlContactOverflow = urlContactOverflow.textContent;
        const isPathSkipped = updatedUrlContactOverflow.length > 0;
        urlArray.forEach((path: string) => {
            if (!isPathSkipped && urlContact.textContent.length + path.length < 41) {
                urlContact.textContent += `${path}/`;
            } else {
                updatedUrlContactOverflow += `${path}/`;
            }
        });
        urlContactOverflow.textContent = updatedUrlContactOverflow.replace(/\/$/, "");
    }

    private handleContactLine(contactInfo: string, contactLineId: string) {
        const contactLine = document.getElementById(`svg-${contactLineId}`);
        contactLine.textContent = "";
        const urlContactOverflow = document.getElementById(`svg-${contactLineId}Overflow`);
        urlContactOverflow.textContent = "";

        if (willRequireOverflowContactLine(contactInfo) && urlRegex.test(contactInfo)) {
            const urlArray = contactInfo.split("/");

            this.addHttpsToContact(urlArray, contactLine);
            this.addOverflowToContact(urlArray, contactLine, urlContactOverflow);
            return;
        }
        contactLine.textContent = contactInfo;
        this.decreaseFontSize(contactLine);
        this.hideUrlContactOverflowContent(urlContactOverflow);
    }
}
